<i18n lang="yaml">
ja:
  mainlogo: ロゴ名サービス名
en:
  mainlogo: logo name
</i18n>

<template>
  <header class="ho-the-header"></header>
</template>

<script lang="ts" setup>
/*
 * const props = withDefaults(
 *   defineProps<{
 *   hoge: boolean
 *   fuga?: string
 * }>(),
 * {
 *   hoge: false
 * })
 */
</script>

<style scoped lang="scss">
// .ho-the-header{}
</style>
